import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { Report } from '@mi-front/core';
import { Box } from '@mui/material';
import { useCanDeleteReport } from '../gip/gip-report/helpers';
import { ReportDeleteBtn } from './ReportDeleteBtn';

export function ReportHeaderActions({ report }: { report: Report }) {
  const auth = useAuth();
  const canDelete = useCanDeleteReport(auth.user, report);

  return <Box>{canDelete && <ReportDeleteBtn id={report.id} name={report.name} />}</Box>;
}
